import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root',
})
export class ProfilePhotoService {
  private cache = new Map<string | number, string>();
  private pending = new Map<string | number, Promise<string | null>>();

  constructor(private usersService: UsersService) {}

  getPhotoUrl(userId: string | number, gravatarHash?: string): Promise<string | null> {
    const defaultUrl = gravatarHash
      ? `//www.gravatar.com/avatar/${gravatarHash}?d=retro&s=40`
      : null;
    if (this.cache.has(userId)) {
      const cached = this.cache.get(userId);
      if (cached) return Promise.resolve(cached);
    }
    if (this.pending.has(userId)) {
      return this.pending.get(userId)!;
    }
    const promise = firstValueFrom(
      this.usersService.getUserSettings(userId),
    )
      .then((response: any) => {
        this.pending.delete(userId);
        const photoSetting = response?.results?.find(
          (s: any) => s.config_key === 'profile_photo',
        );
        const photoUrl = photoSetting?.config_value?.photo_url || defaultUrl;
        if (photoUrl) {
          this.cache.set(userId, photoUrl);
        }
        return photoUrl;
      })
      .catch(() => {
        this.pending.delete(userId);
        return defaultUrl;
      });
    this.pending.set(userId, promise);
    return promise;
  }

  getCachedPhotoUrl(userId: string | number): string | null {
    return this.cache.get(userId) || null;
  }

  clearCache(userId: string | number): void {
    this.cache.delete(userId);
    this.pending.delete(userId);
  }
}
